<div *ngIf="tag !== null">
    <nav class="navbar navbar-dark">
        <div class="container">
            <span class="navbar-brand mb-0">{{tag.name}}</span>
            <ul class="navbar-nav ml-auto">
                <li class="nav-item">
                    <button routerLink="" class="btn btn-primary btn-header">Zurück</button>
                </li>
            </ul>
        </div>
    </nav>

    <div id="impuls" class="container">
        <h1>{{tag.titel}}</h1>
        <p>Von {{tag.autor}}</p>

        <audio *ngIf="tag.id < 100" controls src='../../assets/{{tag.id}}.mp3' type="audio/mp3">Der aktuelle Browser kann diese Audiodatei
            nicht wiedergeben.</audio>

        <div *ngIf="tag.bibelvers != ''" class="bibel">
            <p>{{tag.bibelvers}}</p>
            <p class="mb-0">{{tag.bibelstelle}}</p>
        </div>

        <div id="text" [innerHTML]="text"></div>
        <button routerLink="" class="btn btn-primary btn-back">Zurück zum Kalender</button>
    </div>
</div>


<div *ngIf="tag == null">
    <nav class="navbar navbar-dark">
        <div class="container">
            <span class="navbar-brand mb-0">Fehler</span>
            <ul class="navbar-nav ml-auto">
                <li class="nav-item">
                    <button routerLink="" class="btn btn-primary btn-header">Zurück</button>
                </li>
            </ul>
        </div>
    </nav>

    <div class="container">
        <p>Bitte Türchen nur über den Kalender und nicht über die URL öffnen.</p>
        <button routerLink="" class="btn btn-primary btn-back">Zurück zum Kalender</button>
    </div>
</div>